import { Link, useLocation } from "react-router";

const SidebarItem = ({ link, onClick }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(link.href);

  return (
    <li key={link.title} id={link.tourId} data-tour={link.tourId}>
      <Link
        to={link.href}
        onClick={onClick}
        className={`flex items-center gap-4 px-4 py-3 rounded-lg transition-colors focus:outline-none focus:bg-blue-100 active:bg-blue-200 ${
          isActive ? "bg-blue-100 text-blue-600" : "hover:bg-base-300"
        }`}
      >
        <span className={`${isActive ? "text-blue-600" : "opacity-66"} transition-colors`}>
          {link.icon}
        </span>

        <span className={`${isActive ? "font-semibold text-blue-600" : "opacity-66"}`}>
          {link.title}
        </span>

        {link.badge && <span className="badge badge-primary ml-auto">{link.badge}</span>}
      </Link>
    </li>
  );
};

export default SidebarItem;
